import { useEffect, useState } from 'react';
import { DynamicEpisodesModel } from '../../models/DynamicEpisodesModel';

const useLatestEpisodesQuery = (dataSource) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        setIsLoading(true); // Set loading state to true when starting fetching

        try {
            const urlWithParams = new URL(location.origin + dataSource.apiUrl);
            const params = {
                pageId: dataSource.pageId,
                episodeSlug: dataSource.episodeSlug,
                postsCount: dataSource.postsCount,
            };
            Object.keys(params).forEach((key) => urlWithParams.searchParams.append(key, params[key]));
            const response = await fetch(urlWithParams);

            if (!response.ok) {
                throw new Error('Error fetching data');
            }

            const jsonData = await response.json();
            setData(jsonData);
        } catch (error) {
            console.error(error);
            setError(error);
        } finally {
            setIsLoading(false); // Set loading state to false after fetching
        }
    };

    useEffect(() => {
        if (dataSource?.apiUrl && dataSource.source === 'dynamic') {
            fetchData();
        } else {
            setIsLoading(false); // Set loading state to false if dataSource is not provided or not dynamic
            setData(null); // Clear data
        }

        // Cleanup function
        return () => {
            setData(null); // Clear data when unmounting to prevent memory leaks
        };
    }, [dataSource]);

    // Create model object based on fetched data
    const model = new DynamicEpisodesModel(data);

    return {
        model,
        error,
        isLoading,
    };
};

export default useLatestEpisodesQuery;
